<template>
    <div class="login-page">
        <div class="container shadow mx-3">
            <div class="row">
                <div class="col-md-6 py-3 py-sm-5 bg-danger">
                    <div class="px-5">
                        <div class="px-3 px-sm-5">
                            <img src="../assets/logo.png" class="img-fluid" />
                        </div>
                        <img src="../assets/login-illus.svg" class="img-fluid d-none d-md-block" />
                    </div>
                </div>
                <div class="col-md-6 py-5 px-4 p-sm-5 bg-white">
                    <div class="d-flex align-items-center justify-content-center h-100">
                        <div v-if="!isLoginCodeNumber" class="w-100">
                            <h2>Login</h2>
                            <p class="text-muted">Welcome back, please login to your account.</p>
                            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                <form @submit.prevent="handleSubmit(login)" action="">
                                    <div class="form-group">
                                        <label for="username">Username</label>
                                        <ValidationProvider
                                            v-slot="{ errors }"
                                            vid="username"
                                            name="Username"
                                            rules="required"
                                        >
                                            <input
                                                v-model="form.username"
                                                :class="{ 'form-control': true, 'is-invalid': errors[0] }"
                                                type="text"
                                            />
                                            <span class="invalid-feedback">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <label for="password">Password</label>
                                        <ValidationProvider name="Password" rules="required" v-slot="{ errors }">
                                            <input
                                                v-model="form.password"
                                                :class="{ 'form-control': true, 'is-invalid': errors[0] }"
                                                type="password"
                                            />
                                            <span class="invalid-feedback">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group">
                                        <button
                                            :disabled="isLogin"
                                            class="btn btn-danger btn-block"
                                            style="font-size: 1.2em"
                                        >
                                            <i v-if="isLogin" class="fas fa-sync-alt fa-spin fa-loader ml-2 mr-2"></i>
                                            Login
                                        </button>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                        <div v-else class="w-100">
                            <div v-if="!dataOtps.is_google2fa">
                                <h2>Enter Code</h2>
                                <p class="text-muted">We sent OTP code to your email address.</p>
                                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                    <form @submit.prevent="handleSubmit(loginOtp)" action="">
                                        <div class="form-group">
                                            <label for="otp">Enter code</label>
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                vid="otp"
                                                name="Otp number"
                                                rules="required"
                                            >
                                                <input
                                                    v-model="otpNumber"
                                                    v-on:keypress="numbersOnly"
                                                    :class="{ 'form-control': true, 'is-invalid': errors[0] }"
                                                    maxlength="6"
                                                    type="text"
                                                />
                                                <span class="invalid-feedback">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group">
                                            <button
                                                :disabled="isLogin"
                                                class="btn btn-danger btn-block"
                                                style="font-size: 1.2em"
                                            >
                                                <i
                                                    v-if="isLogin"
                                                    class="fas fa-sync-alt fa-spin fa-loader ml-2 mr-2"
                                                ></i>
                                                Login
                                            </button>
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                            <div v-else class="w-100">
                                <h2>Two-step authentication</h2>
                                <p class="text-muted">Enter 6-digit code from your two factor authenticator app</p>
                                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                    <form @submit.prevent="handleSubmit(loginGoogle2fa)" action="">
                                        <div class="form-group">
                                            <ValidationProvider
                                                v-slot="{ errors }"
                                                vid="2fa"
                                                name="Google 2fa number"
                                                rules="required"
                                            >
                                                <input
                                                    v-model="google2faNumber"
                                                    v-on:keypress="numbersOnly"
                                                    :class="{ 'form-control': true, 'is-invalid': errors[0] }"
                                                    maxlength="6"
                                                    type="text"
                                                />
                                                <span class="invalid-feedback">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group">
                                            <button
                                                :disabled="isLogin"
                                                class="btn btn-danger btn-block"
                                                style="font-size: 1.2em"
                                            >
                                                <i
                                                    v-if="isLogin"
                                                    class="fas fa-sync-alt fa-spin fa-loader ml-2 mr-2"
                                                ></i>
                                                Login
                                            </button>
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import helpers from '@/service/helpers'
import { currentUser } from '@/service/user'
import helperMixin from '@/mixins/helper'

extend('required', {
    ...required,
    message: '{_field_} is required'
})

export default {
    name: 'login',

    mixins: [helperMixin],

    components: {
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            form: {
                username: '',
                password: ''
            },
            isOtpModal: false,
            dataOtps: {},
            isLoginCodeNumber: false,
            otpNumber: '',
            google2faNumber: '',
            isLogin: false
        }
    },

    mounted() {
        console.log(this.devMode)
    },

    methods: {
        ...helpers,

        login() {
            this.isLogin = true

            if (this.devMode) {
                this.$store
                    .dispatch('user/login', this.form)
                    .then(() => {
                        if (currentUser().role === 'translator') {
                            return this.$router.replace({ name: 'language.index' })
                        }

                        this.$router.push({ name: 'dashboard' })
                    })
                    .catch(() => {
                        this.isLogin = false

                        this.$refs.form.setErrors({
                            username: ['This user not found in system']
                        })
                    })
            } else {
                this.$store
                    .dispatch('user/checkLogin', this.form)
                    .then(res => {
                        this.dataOtps = res.data.data
                        this.isLoginCodeNumber = true
                        this.isLogin = false
                    })
                    .catch(() => {
                        this.isLogin = false

                        this.$refs.form.setErrors({
                            username: ['This user not found in system']
                        })
                    })
            }
        },

        loginOtp() {
            this.isLogin = true
            this.dataOtps.otp = this.otpNumber

            this.$store
                .dispatch('user/loginOtp', this.dataOtps)
                .then(() => {
                    if (currentUser().role === 'translator') {
                        return this.$router.replace({ name: 'language.index' })
                    }

                    this.$router.push({ name: 'dashboard' })
                })
                .catch(() => {
                    this.isLogin = false

                    this.$refs.form.setErrors({
                        otp: ['This otp not found in system']
                    })
                })
        },

        loginGoogle2fa() {
            this.isLogin = true
            this.dataOtps.otp = this.google2faNumber

            this.$store
                .dispatch('user/loginGoogle2fa', this.dataOtps)
                .then(() => {
                    if (currentUser().role === 'translator') {
                        return this.$router.replace({ name: 'language.index' })
                    }

                    this.$router.push({ name: 'dashboard' })
                })
                .catch(() => {
                    this.isLogin = false

                    this.$refs.form.setErrors({
                        '2fa': ['This google 2fa not found in system']
                    })
                })
        },

        numbersOnly(evt) {
            evt = evt ? evt : window.event
            var charCode = evt.which ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault()
            } else {
                return true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.login-page {
    background-image: url('../assets/login-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    @media (max-width: 767px) {
        .row {
            flex-direction: column;
        }
    }
}
</style>
